import { Permissions } from './../../../../core/constants/permissions';
import { Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TrialService } from "../../../../core/services/trial.service";
import { TrialPatientList } from "../../../../core/models/trial-patient-list.model";
import { AlertService } from "../../../../shared/alert/alert.service";
import { AuthService } from '../../../../core/services/auth.service';
import { TrialAssignPatientModalComponent } from '../trial-assign-patient-modal/trial-assign-patient-modal.component';
import { TrialState, TrialStateString } from 'app/core/constants/trial-constants';
import { FormControl, FormGroup } from "@angular/forms";
import { LogHelper } from "../../../../core/helpers/log.helper";
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-trial-patients',
  templateUrl: './trial-patients.component.html',
  encapsulation: ViewEncapsulation.None
})
export class TrialPatientsComponent implements OnInit {
  @ViewChild('assignPatientModal') assignPatientModal: TrialAssignPatientModalComponent;

  @Input('apiEnabled') apiEnabled: boolean = false;

  results = new TrialPatientList();
  trialId: string;
  trialCode: string;
  addPatientAvailable: boolean = false;
  dataLoaded: boolean = false;
  loaderArray: number[] = [1,1,1,1,1,1,1,1,1,1];

  searchForm = new FormGroup({
    searchInput: new FormControl<string>(null)
  });

  Permissions = Permissions;

  constructor(public authService: AuthService, private readonly trialService: TrialService, private readonly activatedRoute: ActivatedRoute, private readonly alertService: AlertService,
    private readonly router: Router) {
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this.trialId = params.id;

      this.loadTrial();

      // Debounce search input changes
      this.searchForm.controls.searchInput.valueChanges
        .pipe(
          debounceTime(300),
          distinctUntilChanged()
        )
        .subscribe((searchInput: string) => {
          this.loadPatients(1, searchInput ? searchInput.toLowerCase() : null);
        });
    });
  }

  onSearchInputChanged(searchInput: string): void {
    LogHelper.log('searchInputChanged ' + searchInput)
  }

  onPatientClick(patientId: string) {
    void this.router.navigate(['/patient', patientId]);
  }

  onShowAssignPatientModal(): void {
    this.assignPatientModal.show(this.trialId, this.trialCode);
  }

  loadTrial(): void {
    this.trialService.retrieveTrial(this.trialId).subscribe({
      next: trial => {
        this.trialCode = trial.code;
        this.addPatientAvailable = trial.state === TrialStateString.Values[TrialState.Live];

        this.loadPatients(1);
      }
    });
  }

  loadPatients(pageNo: number, keywords: string = null) {
    this.dataLoaded = false;
    this.trialService.retrievePatients(this.trialId, pageNo, keywords).subscribe({
      next: trialPatientList => {
        this.results = trialPatientList;
        this.dataLoaded = true;
      },
      error: () => {
        this.dataLoaded = true;
        this.alertService.showWarningAlert('There was a problem loading patients!');
      }
    });
  }

  onPatientAssigned(): void {
    this.loadPatients(1);
  }
}
